import { fromJS } from 'immutable';
import { takeLatest, put, select } from 'redux-saga/effects';
import { SET_PROJECT, SET_PROJECT_UNDOABLE } from './project';
import PicabooConstants from '../common/PicabooConstants';
import * as Selectors from '../reducers/selectors';

export const SET_WRAP_VISIBILITY = 'SET_WRAP_VISIBILITY';
export const SET_WRAP_DIMENSIONS = 'SET_WRAP_DIMENSIONS';
export const SET_WRAP_TEXT = 'SET_WRAP_TEXT';

const initialState = fromJS({
  showWrap: false,
  showSpine: false,
  showLines: false,
  showFill: false,
  horizontalWrap: 0,
  verticalWrap: 0,
  invert: false,
  textWrap: '',
  showText: true,
});

/**
 * Reducers
 */

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WRAP_VISIBILITY:
      return state.merge({
        showWrap: action.showWrap,
        showSpine: action.showSpine,
        showLines: action.showLines,
        showFill: action.showFill,
        invert: action.invert,
        loaded: true,
      });

    case SET_WRAP_DIMENSIONS:
      return state.merge({
        horizontalWrap: action.horizontalWrap,
        verticalWrap: action.verticalWrap,
        loaded: true,
      });

    case SET_WRAP_TEXT:
      return state.merge({
        textWrap: action.textWrap,
        showText: action.showText,
        loaded: true,
      });
  }

  return state;
};

/**
 * actions
 */

export function setWrapVisibility(
  showWrap,
  showSpine,
  showLines,
  showFill,
  invert,
) {
  return {
    type: SET_WRAP_VISIBILITY,
    showWrap,
    showSpine,
    showLines,
    showFill,
    invert,
  };
}

export function setWrapDimensions(horizontalWrap, verticalWrap) {
  return {
    type: SET_WRAP_DIMENSIONS,
    horizontalWrap,
    verticalWrap,
  };
}

export function setWrapText(textWrap, showText) {
  return {
    type: SET_WRAP_TEXT,
    textWrap,
    showText,
  };
}

export function* processWrap(action) {
  try {
    const project = action.project;
    let productInfo = project.productInfo;
    if (!productInfo) {
      productInfo = yield select(Selectors.projectProductInfoSelector);
      productInfo = productInfo.toJS();
    }

    if (project.project.type !== undefined) {
      switch (project.project.type) {
        case PicabooConstants.PRODUCT_TYPES.BOOK:
          const sections = yield select(Selectors.projectSectionsSelector);
          const currentSection = sections.get(project.currentSection).toJS();
          const metadata = yield select(Selectors.projectMetadataSelector);
          const style = metadata.get('style');

          if (
            currentSection.type == PicabooConstants.SECTION_TYPES.TYPE_COVER &&
            productInfo.wrappedCover
          ) {
            yield put(setWrapVisibility(true, true, true, true, false));
            if (productInfo.showWrappedText === false) {
              yield put(setWrapText(null, false));
            }
          } else {
            yield put(setWrapVisibility(false, false, false, false, false));
          }

          break;
        case PicabooConstants.PRODUCT_TYPES.SQUARE_PRINT:
          yield put(setWrapVisibility(false, false, false, false, false, true));
          break;
        case PicabooConstants.PRODUCT_TYPES.PHOTO_PANEL:
        case PicabooConstants.PRODUCT_TYPES.METAL_PRINT:
        case PicabooConstants.PRODUCT_TYPES.MOUSE_PAD:
        case PicabooConstants.PRODUCT_TYPES.COASTER:
        case PicabooConstants.PRODUCT_TYPES.PLAYING_CARDS:
          yield put(
            setWrapDimensions(productInfo.coverWrapX, productInfo.coverWrapY),
          );
          yield put(setWrapVisibility(true, false, false, true, false));
          yield put(setWrapText('', false));
          break;
        case PicabooConstants.PRODUCT_TYPES.MUG:
          yield put(
            setWrapDimensions(productInfo.coverWrapX, productInfo.coverWrapY),
          );
          yield put(setWrapVisibility(false, false, false, true, false));
          yield put(setWrapText('', false));
          break;

        case PicabooConstants.PRODUCT_TYPES.CANVAS:
          yield put(
            setWrapDimensions(productInfo.coverWrapX, productInfo.coverWrapY),
          );
          yield put(setWrapVisibility(true, false, false, false, true));
          //yield put(setWrapText('This area will be wrapped around the edge of the canvas', true));
          break;
        case PicabooConstants.PRODUCT_TYPES.YEARBOOK:
          const ybSections = yield select(Selectors.projectSectionsSelector);
          const ybSection = ybSections.get(project.currentSection).toJS();
          if (ybSection.type === PicabooConstants.SECTION_TYPES.TYPE_COVER) {
            yield put(
              setWrapDimensions(productInfo.coverWrapX, productInfo.coverWrapY),
            );
            yield put(setWrapVisibility(true, true, true, true, false));
          } else if (
            ybSection.type == PicabooConstants.SECTION_TYPES.TYPE_SOFTCOVER
          ) {
            yield put(
              setWrapDimensions(
                productInfo.softCoverWrapX,
                productInfo.softCoverWrapY,
              ),
            );
            yield put(setWrapVisibility(true, true, true, true, false));
          } else {
            yield put(setWrapVisibility(false, false, false, false, false));
          }
          break;
        case PicabooConstants.PRODUCT_TYPES.PILLOW:
        case PicabooConstants.PRODUCT_TYPES.BLANKET:
          if (productInfo.availableSizes) {
            let size = productInfo.availableSizes.find((s) => {
              return s.id == project.project.previewSize;
            });
            if (size) {
              yield put(setWrapDimensions(size.wrapX, size.wrapY));
            }
          }
          yield put(setWrapVisibility(true, false, true, true, true));
          yield put(setWrapText('This area will be sewn together', true));

          break;
        case PicabooConstants.PRODUCT_TYPES.TOTE:
          yield put(
            setWrapDimensions(productInfo.coverWrapX, productInfo.coverWrapY),
          );
          yield put(setWrapVisibility(true, false, true, true, true));
          yield put(setWrapText('This area will be sewn together', true));
          break;
        case PicabooConstants.PRODUCT_TYPES.JOURNAL:
          yield put(
            setWrapDimensions(productInfo.coverWrapX, productInfo.coverWrapY),
          );
          yield put(setWrapVisibility(true, true, true, true, false));
        case PicabooConstants.PRODUCT_TYPES.ORNAMENT:
          yield put(
            setWrapDimensions(productInfo.coverWrapX, productInfo.coverWrapY),
          );
          yield put(setWrapVisibility(true, false, false, true, false));
          break;
        case undefined:
          break;
        case PicabooConstants.PRODUCT_TYPES.COLLAGE:
        default:
          yield put(setWrapText('', false));
          break;
      }
    }
  } catch (error) {
    console.error('error processing wrap', error);
  }
}

function* setupSagas() {
  yield takeLatest([SET_PROJECT, SET_PROJECT_UNDOABLE], processWrap);
}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: reducer,
  saga: setupSagas,
};
